import { z } from 'zod'

import {
  BrandInterface,
  CategoryInterface,
  CountryInterface,
  NomenclatureGroupInterface,
  UnitOfMeasurementInterface,
} from '@/types'

const nomenclatureGroupModelSchema = z.object({
  id: z.string(),
  parentId: z.string(),
  isGroup: z.boolean(),
  code: z.number(),
  description: z.string(),
})

export const nomenclatureGroupSchema: z.ZodType<NomenclatureGroupInterface> =
  z.lazy(() =>
    z.object({
      nomenclatureGroup: nomenclatureGroupModelSchema,
      childGroups: z.array(nomenclatureGroupSchema),
    })
  )

export const categoryWithoutChildsSchema: z.ZodType<
  CategoryInterface['category']
> = z.object({
  id: z.string(),
  parentId: z.string(),
  code: z.number(),
  description: z.string(),
  priority: z.number().optional(),
  status: z.enum(['DRAFT', 'APPROVED', 'REJECTED']).optional(),
})

export const categorySchema: z.ZodType<CategoryInterface> = z.lazy(() =>
  z.object({
    category: categoryWithoutChildsSchema,
    childCategories: z.array(categorySchema),
  })
)

export const countrySchema: z.ZodType<CountryInterface> = z.object({
  id: z.string(),
  code: z.number(),
  description: z.string(),
  alpha2: z.string(),
  alpha3: z.string(),
  fullName: z.string(),
})

export const brandSchema: z.ZodType<BrandInterface> = z.object({
  id: z.string(),
  code: z.number(),
  description: z.string(),
  countryDto: countrySchema.nullable().optional(),
  country: countrySchema.nullable().optional(),
})

export const unitOfMeasurementSchema: z.ZodType<UnitOfMeasurementInterface> =
  z.object({
    id: z.string(),
    code: z.string(),
    description: z.string(),
  })

export const currencySchema = z.object({
  id: z.string(),
  code: z.number(),
  description: z.string(),
  fullName: z.string(),
  synonyms: z.string(),
})

export const paymentTypeSchema = z.object({
  id: z.string(),
  enumOrder: z.number(),
  paymentType: z.enum(['CASH', 'NON_CASH']),
})
